import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import styles from './Modals.scss';

function ModalClose({ onClick }) {
    return (<span
        role="presentation"
        data-action="close-modal"
        className={styles['modal-close']}
        onClick={onClick}
    />)
}

ModalClose.displayName = displayName('Modals/ModalClose');

ModalClose.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default ModalClose;
